module.exports = __webpack_public_path__ + "static/media/banner-image.9f2b9a53.png";